import React, { useMemo } from "react";
import { Card, EmptyState, PriorityIcon, TooltipIcon } from "@sscs/ui";
import { PRIORITY_TO_GRADE, compareValues } from "@sscs/utils";
import RenderChildrenWrapper from "../../common/RenderChildrenWrapper";
import styles from "./issues.module.scss";
// P0..P4 map onto grades F,D,C,B,A (the order the radar used).
const PRIORITY_BARS = [
    { priority: "P0", grade: "F" },
    { priority: "P1", grade: "D" },
    { priority: "P2", grade: "C" },
    { priority: "P3", grade: "B" },
    { priority: "P4", grade: "A" },
];
const LEGEND = [
    { key: "failed", label: "Failed", tone: "fail" },
    { key: "suppressed", label: "Suppressed", tone: "warn" },
    { key: "disabled", label: "Disabled", tone: "neutral" },
];
const PriorityBars = ({ issues, onPriorityLabelClick, }) => {
    const counts = PRIORITY_BARS.map(({ grade }) => issues.priority_count[grade]);
    const maxCount = Math.max(...counts, 1);
    return (React.createElement("div", { className: styles["priority-bars"] },
        React.createElement("h3", { className: styles.subtitle }, "By priority"),
        React.createElement("div", { className: styles["bar-list"] }, PRIORITY_BARS.map(({ priority, grade }) => {
            const count = issues.priority_count[grade];
            return (React.createElement("button", { key: priority, type: "button", className: styles.row, onClick: () => onPriorityLabelClick === null || onPriorityLabelClick === void 0 ? void 0 : onPriorityLabelClick(parseInt(priority[1])) },
                React.createElement("span", { className: styles["row-label"] }, priority),
                React.createElement("span", { className: styles["bar-track"] },
                    React.createElement("span", { className: styles.bar, style: { width: `${(count / maxCount) * 100}%` } })),
                React.createElement("span", { className: styles["row-count"] }, count.toLocaleString())));
        }))));
};
const TopIssuesList = ({ issues, policyStatistics, gradeIconWrapper, }) => {
    const top5 = useMemo(() => issues.top_5_issues.toSorted((first, second) => 
    // 0 is the highest priority, we sort from 0 to 4, then by count
    compareValues(first.priority, second.priority, false) ||
        compareValues(policyStatistics[first.id].violations, policyStatistics[second.id].violations, true)), [issues.top_5_issues, policyStatistics]);
    const hasIssues = top5.length > 0;
    return (React.createElement("div", null, hasIssues ? (React.createElement(React.Fragment, null,
        React.createElement("h3", { className: styles.subtitle }, "5 most important software quality issues"),
        top5.map((issue) => (React.createElement("div", { key: issue.description, className: styles["issues-list"] },
            React.createElement(RenderChildrenWrapper, { wrapper: gradeIconWrapper &&
                    ((children) => gradeIconWrapper(issue, children)) },
                React.createElement("div", { className: styles["priority"] },
                    React.createElement(PriorityIcon, { grade: PRIORITY_TO_GRADE[issue.priority], status: policyStatistics[issue.id].enforcements > 0
                            ? "fail"
                            : "pass", hasIssues: policyStatistics[issue.id].violations > 0 }))),
            React.createElement("div", null, issue.description)))))) : (React.createElement(EmptyState, { subject: "issues" }))));
};
const IssuesPanel = ({ issues, helperText, children, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { details: [
                ...LEGEND.map(({ key, label, tone }) => (React.createElement("span", { key: key, className: styles["legend-item"] },
                    React.createElement("span", { className: styles[`legend-swatch-${tone}`] }),
                    label,
                    " ",
                    issues[`${key}_count`].toLocaleString()))),
                React.createElement(TooltipIcon, { key: "tooltip", size: "xs", title: React.createElement(React.Fragment, null,
                        "Issues found during software package analysis.",
                        issues.disabled_count && (React.createElement("div", { className: styles["tooltip-disabled-issues"] },
                            issues.disabled_count.toLocaleString(),
                            " policies were disabled. Disabled policies impact the analysis result."))) }),
            ], actions: helperText }, "Issues"),
        React.createElement(Card.Content, null,
            React.createElement("div", { className: styles.content }, children))));
};
export default {
    Panel: IssuesPanel,
    TopIssuesList,
    PriorityBars,
};
//# sourceMappingURL=Issues.js.map